import { render, staticRenderFns } from "./contentDetails.vue?vue&type=template&id=8d623a2e&scoped=true&"
import script from "./contentDetails.vue?vue&type=script&lang=js&"
export * from "./contentDetails.vue?vue&type=script&lang=js&"
import style0 from "./contentDetails.vue?vue&type=style&index=0&id=8d623a2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d623a2e",
  null
  
)

export default component.exports